import { Check, CheckCheck } from "lucide-react";
import type { Message } from "@/hooks/useMessaging";

interface MessageBubbleProps {
  message: Message;
  isMine: boolean;
}

export const MessageBubble = ({ message, isMine }: MessageBubbleProps) => {
  const time = new Date(message.created_at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" });

  return (
    <div className={`flex ${isMine ? "justify-end" : "justify-start"} mb-2 px-3`}>
      <div
        className={`max-w-[75%] rounded-2xl px-4 py-2.5 ${
          isMine
            ? "bg-primary/80 backdrop-blur-xl text-primary-foreground rounded-br-md"
            : "bg-muted/60 backdrop-blur-xl text-foreground rounded-bl-md"
        }`}
        style={{
          boxShadow: isMine
            ? "0 2px 12px hsl(var(--primary) / 0.25), inset 0 1px 0 hsl(0 0% 100% / 0.15)"
            : "0 2px 12px hsl(var(--foreground) / 0.06), inset 0 1px 0 hsl(0 0% 100% / 0.3)",
        }}
      >
        {message.message_type === "image" && message.media_url && (
          <img src={message.media_url} alt="" className="rounded-xl mb-1 max-w-full" />
        )}
        {message.message_type === "video" && message.media_url && (
          <video
            controls
            playsInline
            preload="metadata"
            src={message.media_url}
            className="rounded-xl mb-1 max-w-full max-h-64"
          />
        )}
        {message.message_type === "audio" && message.media_url && (
          <audio controls src={message.media_url} className="max-w-full" />
        )}
        {message.content && (
          <p className="text-[15px] leading-relaxed whitespace-pre-wrap break-words">{message.content}</p>
        )}
        <div className={`flex items-center gap-1 mt-1 ${isMine ? "justify-end" : "justify-start"}`}>
          <span className={`text-[11px] ${isMine ? "text-primary-foreground/60" : "text-muted-foreground"}`}>{time}</span>
          {isMine && (
            message.is_read
              ? <CheckCheck className="w-3.5 h-3.5 text-primary-foreground/60" />
              : <Check className="w-3.5 h-3.5 text-primary-foreground/40" />
          )}
        </div>
      </div>
    </div>
  );
};
